import React from 'react';
import { FormControl, Select, MenuItem, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material/Select';
import LanguageIcon from '@mui/icons-material/Language';

interface LanguageSelectorProps {
  size?: 'small' | 'medium';
  sx?: object;
  formDataHook?: string;
  selectDataHook?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  size = 'small',
  sx,
  formDataHook = 'language-select-form',
  selectDataHook = 'language-select',
}) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    const lang = event.target.value as string;
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === 'en' ? 'ltr' : 'rtl';
  };

  return (
    <FormControl
      sx={{ minWidth: 40, width: 'auto', ...sx }}
      size={size}
      data-hook={formDataHook}
      variant="standard"
    >
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        data-hook={selectDataHook}
        displayEmpty
        renderValue={() => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <LanguageIcon fontSize="small" />
          </Box>
        )}
        sx={{
          '& .MuiSelect-select': {
            padding: 0,
            minWidth: 0,
          },
          minWidth: 40,
        }}
        inputProps={{
          'aria-label': 'Select language',
        }}
      >
        <MenuItem value="en">EN</MenuItem>
        <MenuItem value="he">HE</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSelector; 